if (!customElements.get('lf-offer-carousel')) {
  customElements.define('lf-offer-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.slides = [...this.querySelectorAll('[data-offer-slide]')];
      this.controls = this.querySelector('[data-carousel-controls]');
      this.dots = [...this.querySelectorAll('[data-carousel-dot]')];
      this.announcement = this.querySelector('[data-carousel-announcement]');
      this.index = 0;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.querySelector('[data-carousel-prev]').addEventListener('click', () => this.show(this.index - 1, true), options);
      this.querySelector('[data-carousel-next]').addEventListener('click', () => this.show(this.index + 1, true), options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index, true), options));
      this.addEventListener('keydown', event => {
        if (event.altKey || event.ctrlKey || event.metaKey || /INPUT|TEXTAREA|SELECT/.test(event.target.tagName)) return;
        const target = {ArrowLeft:this.index - 1, ArrowRight:this.index + 1, Home:0, End:this.available.length - 1}[event.key];
        if (target === undefined || this.available.length < 2) return;
        event.preventDefault();
        this.show(target, true);
      }, options);
      const viewport = this.querySelector('[data-carousel-viewport]');
      viewport.addEventListener('pointerdown', event => {
        if (event.pointerType === 'mouse') return;
        this.touch = {x:event.clientX,y:event.clientY};
      }, options);
      viewport.addEventListener('pointerup', event => {
        if (!this.touch) return;
        const x = event.clientX - this.touch.x;
        const y = event.clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(x) > 45 && Math.abs(x) > Math.abs(y) * 1.3) {
          this.suppressClick = true;
          this.show(this.index + (x < 0 ? 1 : -1), true);
          setTimeout(() => {this.suppressClick = false;}, 350);
        }
      }, options);
      viewport.addEventListener('pointercancel', () => {this.touch = null;}, options);
      viewport.addEventListener('click', event => {
        if (this.suppressClick) {event.preventDefault();event.stopPropagation();}
      }, {...options,capture:true});
      this.observer = new MutationObserver(() => this.refresh());
      this.observer.observe(viewport, {subtree:true,attributes:true,attributeFilter:['hidden']});
      this.refresh();
    }
    refresh() {
      const previous = this.available?.[this.index];
      this.available = this.slides.filter(slide => {
        const offer = slide.querySelector('[data-lf-promotion]');
        const version = slide.querySelector('[data-lf-promotion-version]');
        return offer && !offer.hidden && (!version || !version.hidden);
      });
      this.hidden = this.available.length === 0;
      this.controls.hidden = this.available.length < 2;
      this.dataset.ready = '';
      this.show(Math.max(0,this.available.indexOf(previous)), false);
    }
    show(index, announce) {
      if (!this.available.length) return;
      this.index = (index + this.available.length) % this.available.length;
      const active = this.available[this.index];
      const moveFocus = this.slides.some(slide => slide !== active && slide.contains(document.activeElement));
      this.slides.forEach(slide => {
        const selected = slide === active;
        slide.classList.toggle('is-active', selected);
        slide.inert = !selected;
        slide.setAttribute('aria-hidden', String(!selected));
        const position = this.available.indexOf(slide);
        slide.setAttribute('aria-label', this.dataset.position.replace('[index]', String(position + 1)).replace('[total]', String(this.available.length)) + ': ' + slide.dataset.label);
      });
      this.dots.forEach((dot, i) => {
        const position = this.available.indexOf(this.slides[i]);
        dot.hidden = position < 0;
        dot.setAttribute('aria-current', String(this.slides[i] === active));
      });
      if (moveFocus) this.querySelector('[data-carousel-next]').focus({preventScroll:true});
      if (announce) this.announcement.textContent = active.getAttribute('aria-label');
    }
    disconnectedCallback() {this.observer?.disconnect();this.observer=null;this.abort?.abort();}
  });
}
